import {
  createYupSchema,
  IValidationsYupRoot,
  METADATA_KEY,
  TCustomProductionFieldName,
} from "@ryde/shared";

export const customProductionValidationRules: Record<
  TCustomProductionFieldName,
  IValidationsYupRoot
> = {
  productionAction: {
    type: "string",
    rules: [
      {
        validation: "required",
      },
    ],
  },
  productionType: {
    type: "array",
    rules: [],
  },
  produceFrom: {
    type: "string",
    rules: [
      {
        validation: "required",
      },
    ],
  },
  produceTo: {
    type: "string",
    rules: [
      {
        validation: "required",
      },
    ],
  },
  shiftIds: {
    type: "array",
    rules: [],
  },
  direction: {
    type: "string",
    rules: [
      {
        validation: "required",
      },
    ],
  },
  areaIds: {
    type: "array",
    rules: [],
  },
  siteIds: {
    type: "array",
    rules: [],
  },
  unitIds: {
    type: "array",
    rules: [],
  },
  passengerTypeId: {
    type: "number",
    rules: [],
  },
  rideTypeId: {
    type: "number",
    rules: [],
  },
  bookingType: {
    type: "string",
    rules: [],
  },
  sectors: {
    type: "array",
    rules: [],
  },
  assignDocksDuringProduction: {
    type: "string",
    rules: [],
  },
  useCustomDirectionsService: {
    type: "bool",
    rules: [],
  },
  directionsService: {
    type: "string",
    rules: [],
  },
  doNotLockBookings: {
    type: "bool",
    rules: [],
  },
};

export const customProductionValidationSchema = createYupSchema(
  Object.keys(customProductionValidationRules).map((key, index) => {
    return {
      id: index,
      name: key as TCustomProductionFieldName,
      isColumn: !key.includes(METADATA_KEY),
      formValidation:
        customProductionValidationRules[key as TCustomProductionFieldName],
    };
  }),
);
